/**
 * API Base URL Configuration
 *
 * Supports multiple hosting environments:
 *
 * 1. CloudFront (AWS) - Default
 *    - No env var needed
 *    - CloudFront rewrites /api/* to backend
 *    - Stores use full paths like /api/v1/users
 *
 * 2. Render.com Static Site
 *    - Set VITE_API_URL to full backend URL (e.g., https://your-backend.onrender.com)
 *    - Stores will prefix requests with this URL
 *
 * 3. Development (Vite)
 *    - No env var needed
 *    - Vite proxy forwards /api/* to localhost:3000
 */

/**
 * Determine the API base URL based on environment configuration
 * @returns {string} The base URL for API requests
 */
export function getApiBaseUrl() {
  // Render.com or custom deployment: use explicit API URL from environment
  if (import.meta.env.VITE_API_URL) {
    // Ensure no trailing slash for consistency
    return import.meta.env.VITE_API_URL.replace(/\/$/, "");
  }

  // CloudFront (production) or Vite (development):
  // Empty string - stores already use full paths like /api/v1/users
  // - CloudFront rewrites /api/* to backend
  // - Vite dev server proxies /api/* to localhost:3000
  return "";
}

/**
 * Get the full API URL for a given path
 * Useful for debugging or constructing full URLs
 * @param {string} path - API path (e.g., /api/v1/users)
 * @returns {string} Full URL
 */
export function getFullApiUrl(path) {
  const baseUrl = getApiBaseUrl();
  return baseUrl ? `${baseUrl}${path}` : path;
}

// Export the base URL directly for convenience
export const API_BASE_URL = getApiBaseUrl();
